import { HttpInterceptorFn } from '@angular/common/http';
import { inject, isDevMode } from '@angular/core';
import { SucursalService } from '@shared/services/sucursal.service';

/**
 * Interceptor que agrega automáticamente el header 'x-sucursal'
 * con el ID de la sucursal activa en todas las peticiones HTTP
 * que requieran el contexto de sucursal.
 */
export const sucursalInterceptor: HttpInterceptorFn = (req, next) => {
  // Endpoints que no requieren el header de sucursal
  const excludedPaths = [
    '/auth/',
    '/usuario/crear-super-usuario',
    '/sucursal/cargar-todos',
    '/sucursal/principal',
  ];

  // Si la URL está excluida, no agregar el header
  if (excludedPaths.some((path) => req.url.includes(path))) {
    return next(req);
  }

  const sucursalState = inject(SucursalService);
  const sucursalId = sucursalState.activeSucursal()?.id;
  // Si no hay sucursal activa, continuar sin el header
  // (el backend responderá con error si es requerido)
  if (!sucursalId) {
    if (isDevMode()) {
      console.warn('Sucursal Interceptor: No hay sucursal activa, request sin header x-sucursal');
    }
    return next(req);
  }

  // Agregar el header x-sucursal a la petición
  const sucursalReq = req.clone({
    setHeaders: {
      'x-sucursal': sucursalId.toString(),
    },
  });
  return next(sucursalReq);
};
